(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TestPlanCreateController', TestPlanCreateController);

    TestPlanCreateController.$inject = ['TestPlan', '$translate'];

    function TestPlanCreateController(TestPlan, $translate) {
        var vm = this;

        vm.allUsers = [];
        vm.filteredUsers = [];
        vm.availableAgences = [];
        vm.availableRoles = [];
        vm.filter = null;
        vm.selectedAgenceId = null;
        vm.selectedRole = null;
        vm.selectedUsers = {};
        vm.selectAllVisible = false;
        vm.planFile = null;
        vm.errorMessage = null;
        vm.successMessage = null;
        vm.isLoadingUsers = false;
        vm.isSubmitting = false;

        vm.applyFilters = applyFilters;
        vm.clearMessages = clearMessages;
        vm.clearSelection = clearSelection;
        vm.createPlan = createPlan;
        vm.filteredUserCount = filteredUserCount;
        vm.hasUsers = hasUsers;
        vm.isUserSelected = isUserSelected;
        vm.resetFilters = resetFilters;
        vm.selectedCount = selectedCount;
        vm.setPlanFile = setPlanFile;
        vm.toggleSelectAllVisible = toggleSelectAllVisible;
        vm.updateSelectAllVisibleState = updateSelectAllVisibleState;

        activate();

        function activate() {
            loadUsers();
        }

        function loadUsers() {
            vm.isLoadingUsers = true;
            clearMessages();

            // Charger tous les destinataires de l'organisation, quelle que soit leur zone.
            TestPlan.assignableUsers(function(result) {
                vm.isLoadingUsers = false;
                vm.allUsers = sortUsers((result || []).filter(function(user) {
                    return user && user.activated;
                }));
                vm.availableRoles = buildRoleOptions(vm.allUsers);
                vm.availableAgences = buildAgenceOptions(vm.allUsers);
                applyFilters();
            }, function(response) {
                vm.isLoadingUsers = false;
                vm.allUsers = [];
                vm.filteredUsers = [];
                vm.availableRoles = [];
                vm.availableAgences = [];
                vm.errorMessage = resolveErrorMessage(response, $translate.instant('testPlan.create.loadUsersError'));
            });
        }

        function setPlanFile(file) {
            vm.planFile = file;
            vm.successMessage = null;
        }

        function applyFilters() {
            var normalizedFilter = normalizeText(vm.filter);

            vm.filteredUsers = vm.allUsers.filter(function(user) {
                return matchesFilter(user, normalizedFilter)
                    && matchesRole(user, vm.selectedRole)
                    && matchesAgence(user, vm.selectedAgenceId);
            });

            updateSelectAllVisibleState();
        }

        function resetFilters() {
            vm.filter = null;
            vm.selectedRole = null;
            vm.selectedAgenceId = null;
            applyFilters();
        }

        function hasUsers() {
            return vm.filteredUsers.length > 0;
        }

        function filteredUserCount() {
            return vm.filteredUsers.length;
        }

        function isUserSelected(login) {
            return !!vm.selectedUsers[login];
        }

        function selectedCount() {
            return vm.allUsers.filter(function(user) {
                return !!vm.selectedUsers[user.login];
            }).length;
        }

        function clearSelection() {
            vm.selectedUsers = {};
            vm.selectAllVisible = false;
        }

        function toggleSelectAllVisible() {
            vm.filteredUsers.forEach(function(user) {
                vm.selectedUsers[user.login] = vm.selectAllVisible;
            });
        }

        function updateSelectAllVisibleState() {
            vm.selectAllVisible = vm.filteredUsers.length > 0 && vm.filteredUsers.every(function(user) {
                return !!vm.selectedUsers[user.login];
            });
        }

        function createPlan() {
            var selectedUserLogins = vm.allUsers.filter(function(user) {
                return !!vm.selectedUsers[user.login];
            }).map(function(user) {
                return user.login;
            });

            clearMessages();

            if (!vm.planFile) {
                vm.errorMessage = $translate.instant('testPlan.create.fileRequired');
                return;
            }
            if (selectedUserLogins.length === 0) {
                vm.errorMessage = $translate.instant('testPlan.create.userRequired');
                return;
            }

            vm.isSubmitting = true;
            var formData = new FormData();
            formData.append('file', vm.planFile);
            formData.append('userLogins', angular.toJson(selectedUserLogins));

            TestPlan.upload({}, formData, function(result) {
                vm.isSubmitting = false;
                vm.successMessage = buildSuccessMessage(result, selectedUserLogins.length);
                vm.planFile = null;
                clearSelection();
                angular.element('#testPlanCreateFile').val(null);
            }, function(response) {
                vm.isSubmitting = false;
                vm.errorMessage = resolveErrorMessage(response, $translate.instant('testPlan.create.createError'));
            });
        }

        function clearMessages() {
            vm.errorMessage = null;
            vm.successMessage = null;
        }

        function buildSuccessMessage(result, selectedCountValue) {
            var title = result && result.title ? result.title : $translate.instant('testPlan.create.defaultPlanTitle');
            var assignedCount = result && result.assignedCount ? result.assignedCount : selectedCountValue;
            return $translate.instant('testPlan.create.createSuccess', {
                title: title,
                count: assignedCount
            });
        }

        function buildRoleOptions(users) {
            var roleMap = {};
            users.forEach(function(user) {
                angular.forEach(user.authorities || [], function(authority) {
                    if (authority) {
                        roleMap[authority] = true;
                    }
                });
            });
            return Object.keys(roleMap).sort();
        }

        function buildAgenceOptions(users) {
            var agenceMap = {};
            users.forEach(function(user) {
                angular.forEach(user.agencesRattachement || [], function(agence) {
                    if (agence && agence.id && !agenceMap[agence.id]) {
                        agenceMap[agence.id] = {
                            id: agence.id,
                            nom: agence.nom
                        };
                    }
                });
            });
            return Object.keys(agenceMap).map(function(key) {
                return agenceMap[key];
            }).sort(function(left, right) {
                return (left.nom || '').localeCompare(right.nom || '');
            });
        }

        function sortUsers(users) {
            return users.sort(function(left, right) {
                return buildUserLabel(left).localeCompare(buildUserLabel(right));
            });
        }

        function buildUserLabel(user) {
            return [
                normalizeText(user.lastName),
                normalizeText(user.firstName),
                normalizeText(user.login)
            ].join('|');
        }

        function matchesFilter(user, normalizedFilter) {
            if (!normalizedFilter) {
                return true;
            }

            return [
                user.login,
                user.email,
                user.firstName,
                user.lastName
            ].some(function(value) {
                return normalizeText(value).indexOf(normalizedFilter) !== -1;
            });
        }

        function matchesRole(user, selectedRole) {
            if (!selectedRole) {
                return true;
            }
            return (user.authorities || []).indexOf(selectedRole) !== -1;
        }

        function matchesAgence(user, selectedAgenceId) {
            if (!selectedAgenceId) {
                return true;
            }
            return (user.agencesRattachement || []).some(function(agence) {
                return agence && String(agence.id) === String(selectedAgenceId);
            });
        }

        function normalizeText(value) {
            return (value || '').toString().toLowerCase();
        }

        function resolveErrorMessage(response, defaultMessage) {
            var headerDetail = readHeader(response, 'X-wamasysApp-detail');
            if (headerDetail) {
                return headerDetail;
            }
            if (response && response.data) {
                if (angular.isString(response.data)) {
                    return response.data;
                }
                if (response.data.message) {
                    return response.data.message;
                }
                if (response.data.error_description) {
                    return response.data.error_description;
                }
            }
            return defaultMessage;
        }

        function readHeader(response, headerName) {
            if (!response || !response.headers) {
                return null;
            }
            return response.headers(headerName) || response.headers(headerName.toLowerCase());
        }
    }
})();
